

const Details = () => {
  return (
    <main className="page">
      <section className="details">
        <div className="details__container">
          <div className="details__title-wrapper">
            <h1 className="details__title details__fonts-style">
              Здравствуйте вас приветствует логистическая компания ADES EXPRESS. 7-12
              дней со дня поступления на склад.
            </h1>
          </div>
          <h2 className="details__subtitle details__fonts-style">
            Дорогие клиенты перед тем, как оформлять заказ, просим внимательно
            прочитать условия заказа!
          </h2>
          <ul className="details__list">
            <li className="details__items">
              Внимательно прочитайте список запрещенных товаров.
            </li>
            <li className="details__items">
              Хрупкие, легко ломающиеся товары просим не заказывать. При случае заказа
              сообщать заранее.
            </li>
            <li className="details__items">
              За заводской брак ответственность не несем.
            </li>
            <li className="details__items">
              Проверяйте личный код и адрес при заказе.
            </li>
            <li className="details__items">
              При заказе габаритных товаров просим предупреждать
            </li>
            <li className="details__items">
              Также за обрешетку взимается плата и вес товара считается вместе с
              обрешеткой.
            </li>
            <li className="details__items">
              Купленный товар возврату не подлежит- мы отвечаем только за перевозку
            </li>
            <li className="details__items">
              Сроки доставки указаны без учета задержек и форс мажорных ситуаций.
            </li>
            <li className="details__items">Минимальный допустимый вес 0,1кг.</li>
            <li className="details__items">
              Вес считается вместе с упаковкой (упаковка вашего поставщика).
            </li>
            <li className="details__items">
              Бесплатное хранение -15 дней, далее-20 сом . После 1 месяца- идёт
              утилизация товара!
            </li>
          </ul>
          <h2 className="details__red-subtitle details__fonts-style">
          Запрещенные товары:
          </h2>
          <ul className="details__red-list">
            <li className="details__red-items">
            Униформы и др. товары военного назначения
            </li>
            <li className="details__red-items">Продукты- скоропорт- фрукты, жидкость и т.д.</li>
            <li className="details__red-items">
            Оружие, горючие смеси, газы в болонах
            </li>
            <li className="details__red-items">Мед.аппараты- всё что связано со здоровьем</li>
            <li className="details__red-items">Большие зеркала, большие телевизоры и мониторы</li>
            <li className="details__red-items">
            Телефоны
            </li>
          </ul>
          <div className="details__text-wrapper">
            <p className="details__fonts-style">
            Условия компании <br /><br />

Уважаемые клиенты,<br />
Обращаем ваше внимание, что наша компания оказывает услуги по транспортировке грузов и не несет ответственности за их сохранность . <br /><br />

Мы настоятельно рекомендуем вам заранее позаботиться о качественной упаковке вашего груза, обеспечивающей его защиту от возможных повреждений в процессе перевозки.<br /><br /><br /><br />



Компания не несет ответственности за повреждения, возникшие вследствие некачественной или неподходящей упаковки. Пожалуйста, убедитесь, что ваша упаковка соответствует всем требованиям для безопасной (жирным шрифтом)транспортировки.<br /><br />

Если у вас возникли вопросы по поводу правильной упаковки, наши специалисты готовы проконсультировать вас и помочь выбрать подходящие решения. <br/> <br /><br/><br/>
🔸 Условия в случае утери груза <br/><br/>

Мы всегда стремимся обеспечить надёжную доставку, но, как и в любом бизнесе, бывают редкие случаи утери груза по вине китайской стороны (например, при ошибочной сортировке).<br/><br/>

В таких ситуациях мы не снимаем с себя ответственность и предлагаем два варианта решения:<br/>
	1.	Возврат полной стоимости посылки по закупочной цене в Китае.<br/>
	2.	Повторный заказ того же товара за наш счёт.<br/><br/>

📌 Обратите внимание:<br/>
Мы компенсируем только сумму, за которую товар был приобретён в Китае. Эти условия являются частью нашей политики и действуют для всех клиентов.<br/><br/>

Пожалуйста, ознакомьтесь с ними до начала сотрудничества, чтобы избежать недоразумений. Благодарим за понимание и доверие!
            </p>
          </div>
          {/* <h2 className="details__attention details__fonts-style">
            ВНИМАНИЕ!
          </h2>
          <h2 className="details__red-title details__fonts-style">
            Если вы хотите заказать жидкость, аккумуляторы, технику и т.д - СВЯЖИТЕСЬ С НАШИМ МЕНЕДЖЕРОМ ОН ВЫДАСТ ВАМ ДРУГОЙ АДРЕС СКЛАДА, ПРИВЕЗЕМ ОТ 50КГ И ВЫШЕ ЛЮБОЙ ТОВАР!
          </h2> */}
        </div>
      </section>
    </main>
  )
}

export default Details